import React from "react";
const ProductIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15 3.125H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.035.84 1.875 1.875 1.875h10c1.035 0 1.875-.84 1.875-1.875V5c0-1.036-.84-1.875-1.875-1.875Z"
    ></path>
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.75 5.625h-7.5a.625.625 0 0 0-.625.625v7.5c0 .345.28.625.625.625h7.5c.345 0 .625-.28.625-.625v-7.5a.625.625 0 0 0-.625-.625Z"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10 3.125v-1.25m3.125 1.25v-1.25m-6.25 1.25v-1.25M10 18.125v-1.25m3.125 1.25v-1.25m-6.25 1.25v-1.25m10-6.875h1.25m-1.25 3.125h1.25m-1.25-6.25h1.25M1.875 10h1.25m-1.25 3.125h1.25m-1.25-6.25h1.25"
    ></path>
  </svg>
);
export default ProductIcon;
